export const HANDLEBARS_DATA_PATH_PREFIX = '@';

export const INVALID_HANDLEBAR_PATH_SEGMENT =
  /(?:^[0-9])|\s|true|false|null|undefined|!|"|#|%|&|'|\(|\)|\*|\+|,|\/|;|<|=|>|@|\[|\\|\]|\^|`|\{|\||\}|~/i;
